import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { ConfigHeader } from '@sierralabs/forms-ui';
import ConfigCard from '@sierralabs/forms-ui/dist/config/components/ConfigCard';
import ConfigContent from '@sierralabs/forms-ui/dist/config/components/ConfigContent';
import { Shape } from '@sierralabs/workflow';

import { Group } from '../../groups/Group.interface';
import GroupSelector from './GroupSelector';

export interface GroupPermissionsSectionProps {
  shape: Shape;
  onChange?: (groups: Group[]) => void;
}

const GroupPermissionsSection: React.FC<GroupPermissionsSectionProps> = (
  props: GroupPermissionsSectionProps
) => {
  const { shape, onChange } = props;
  const groupPermissions: number[] = shape.data?.meta?.groupPermissions || [];
  return (
    <ConfigCard>
      <ConfigHeader>Team Permissions</ConfigHeader>
      <ConfigContent>
        <FormControl className='form-control'>
          <GroupSelector
            multiple
            onChange={onChange}
            value={groupPermissions}
          />
          <FormHelperText className='pad-left'>
            If there are selected Teams, only they can edit the fields selected
            below.
          </FormHelperText>
        </FormControl>
      </ConfigContent>
    </ConfigCard>
  );
};

export default GroupPermissionsSection;
